import { deprecated } from "typesafe-actions";

import type { IServerPager } from "@/shop/types/common";
import type { ITreeMatsQuery, ITreeMatsQueryWhere, ITreeMatsSearchResult } from "@/shop/types/treeSearch";

import { PartTreeSearchActionType } from "./constants";

const { createStandardAction } = deprecated;

// TODO: evaluate moving URLs of tree and materials to meta object

/**
 * Fetch list of search result in this tree
 * - Used by other search actions ins saga
 */
export const fetchResults = createStandardAction(PartTreeSearchActionType.FETCH_RESULTS).map(
  ({ url, query, advancedPOSTLoading }: { url: string; query: ITreeMatsQuery; advancedPOSTLoading: boolean }) => ({
    payload: { url, query, advancedPOSTLoading }
  })
);

export const fetchResultsStart = createStandardAction(PartTreeSearchActionType.FETCH_RESULTS_START).map(
  ({ url, query }: { url: string; query: ITreeMatsQuery }) => ({
    payload: { url, query }
  })
);

export const fetchResultsFail = createStandardAction(PartTreeSearchActionType.FETCH_RESULTS_FAIL)<void>();

export const fetchResultsSuccess = createStandardAction(PartTreeSearchActionType.FETCH_RESULTS_SUCCESS).map((result: ITreeMatsSearchResult) => ({
  payload: { result }
}));

/**
 * Initialize search with tree url
 * - Should be called to fetch initial result list
 * @param payload
 * @param payload.url - URL from where the search results are loaded.
 * @param payload.id - Tree node id, e.g. in `"10-010-0140-0020"` in Paper/Category
 */
export const initSearch = createStandardAction(PartTreeSearchActionType.INIT_SEARCH).map(
  (payload: { url: string; id: string; filter?: ITreeMatsQueryWhere; pager?: IServerPager; advancedPOSTLoading?: boolean }) => ({
    payload: { url: payload.url, id: payload.id, filter: payload.filter, pager: payload.pager, advancedPOSTLoading: payload.advancedPOSTLoading }
  })
);

/**
 * Submit search action.
 * - Triggered when submitting the search form
 * - Can be called after `initSearch` only
 */
export const submitSearch = createStandardAction(PartTreeSearchActionType.SUBMIT_SEARCH).map((query: ITreeMatsQueryWhere) => ({
  payload: query
}));

/**
 * Change page
 * - One-based index
 * - Can be called after `initSearch` only
 */
export const changePage = createStandardAction(PartTreeSearchActionType.CHANGE_PAGE).map((targetPage: number) => ({
  payload: targetPage
}));

/**
 * Change page size
 * - Can be called after `initSearch` only
 */
export const changePageSize = createStandardAction(PartTreeSearchActionType.CHANGE_PAGE_SIZE).map((pageSize: number) => ({
  payload: pageSize
}));

export const changeSort = createStandardAction(PartTreeSearchActionType.CHANGE_SORT).map((sort: string) => ({
  payload: sort
}));

export const changeSortCardsView = createStandardAction(PartTreeSearchActionType.CHANGE_SORT_CARDS_VIEW).map((sort: { id: string; sortDirection: string }) => ({
  payload: sort
}));
